export default __webpack_public_path__ + "static/media/gambarPolusi.4658cbae.jpg";